import { DialogTitle as MuiDialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '~components/button';
import IdTag from '~components/id-tag';
import Typography from '~components/typography';
import { BasicClose } from '~svg-components';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.flex.crossCenter,
    padding: '16px 16px 16px 24px',
  },

  divider: { borderBottom: `1px solid ${theme.colors.greyE8}` },

  actions: {
    ...theme.flex.crossCenter,
    flex: 1,
    '& > *:not(:first-child)': { marginLeft: 12 },
  },

  idTag: { borderRadius: 12 },

  closeButton: {
    width: 32,
    height: 32,
    marginLeft: 'auto',
    color: theme.colors.grey66,
    '&:hover': { color: theme.colors.brandAction },
  },
}));

function DialogTitle(props) {
  const {
    title,
    idNumber,
    actions,
    className,
    onClickCloseButton,
    titleClassName,
    idTagClassName,
    closeButtonClassName,
    closeButton,
    isShowHeaderDivider,
    ...otherProps
  } = props;
  const styles = useStyles();

  return (
    <MuiDialogTitle
      disableTypography
      {...otherProps}
      className={classnames(styles.root, className, {
        [styles.divider]: isShowHeaderDivider,
      })}
    >
      <div className={styles.actions}>
        {title && typeof title === 'string' && (
          <Typography variant="h3" className={titleClassName}>
            {title}
          </Typography>
        )}
        {title && typeof title !== 'string' && title}

        {idNumber && <IdTag className={classnames(styles.idTag, idTagClassName)}>{idNumber}</IdTag>}

        {actions}
      </div>

      {closeButton || (
        <Button
          variant="base"
          className={classnames(styles.closeButton, closeButtonClassName)}
          onClick={onClickCloseButton}
        >
          <BasicClose />
        </Button>
      )}
    </MuiDialogTitle>
  );
}

DialogTitle.propTypes = {
  title: PropTypes.node,
  idNumber: PropTypes.node,
  actions: PropTypes.node,
  onClickCloseButton: PropTypes.func,
  titleClassName: PropTypes.string,
  idTagClassName: PropTypes.string,
  closeButtonClassName: PropTypes.string,
  className: PropTypes.string,
  closeButton: PropTypes.node,
  isShowHeaderDivider: PropTypes.bool,
};

DialogTitle.defaultProps = {
  title: undefined,
  idNumber: undefined,
  actions: undefined,
  onClickCloseButton: undefined,
  titleClassName: undefined,
  idTagClassName: undefined,
  closeButtonClassName: undefined,
  className: undefined,
  isShowHeaderDivider: true,
};

export default DialogTitle;
